import * as types from '../mutation-types'
import * as apis from '../../apis'

let loading = Promise.resolve(true);

const state = {
    shops: [],
    meta: {
        current_page: 0,
        total: 0,
    }
};

const getters = {
    shops: state => state.shops,
    shopMeta: state => state.meta,
    shopById: state => id => state.shops.find(shop => shop.id == id),
};

const actions = {
    getShop({ commit }, payload) {
        return loading.then(() => {
            return apis.getShop(payload).then(res => {
                commit(types.ADD_SHOP, res.data);

                return res;
            });
        })
    },
    getShops({ commit }, payload) {
        loading = apis.getShops(payload).then(res => {
            commit(types.SET_SHOPS, res.data);

            return res;
        });

        return loading;
    },
    loadMoreShops({ commit, state }) {
        return loading.then(() => {
            let payload = {
                page: state.meta.current_page + 1
            };

            return apis.getShops(payload).then(res => {
                commit(types.LOAD_MORE_SHOPS, res.data);

                return res;
            });
        });
    },
    addFavorite({ commit }, shopId) {
        return loading.then(() => {
            return apis.addFavorite(shopId).then(res => {
                commit(types.ADD_FAVORITE, shopId);

                return res;
            });
        });
    },
    deleteFavorite({ commit }, shopId) {
        return loading.then(() => {
            return apis.deleteFavorite(shopId).then(res => {
                commit(types.DELETE_FAVORITE, shopId);

                return res;
            });
        });
    }
};

const mutations = {
    [types.SET_SHOPS](state, shops) {
        state.shops = shops.data;
        state.meta = shops.meta;
    },
    [types.LOAD_MORE_SHOPS](state, shops) {
        state.meta = shops.meta;
        state.shops = state.shops.concat(shops.data).filter((shop, index, shops) => {
            return shops.findIndex(s => s.id === shop.id) === index;
        });
    },
    [types.ADD_SHOP](state, shop) {
        let index = state.shops.findIndex(s => s.id === shop.id);

        if (index >= 0) {
            state.shops.splice(index, 1, shop);
        } else {
            state.shops.push(shop);
        }
    },
    [types.ADD_FAVORITE](state, shopId) {
        let index = state.shops.findIndex(s => s.id === parseInt(shopId));

        if (index < 0) {
            return;
        }

        let shop = state.shops[index];
        shop.is_favorite = 1;
        state.shops.splice(index, 1, shop);
    },
    [types.DELETE_FAVORITE](state, shopId) {
        let index = state.shops.findIndex(s => s.id === parseInt(shopId));

        if (index < 0) {
            return;
        }

        let shop = state.shops[index];
        shop.is_favorite = 0;
        state.shops.splice(index, 1, shop);
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
